import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import analytics from 'rewind-analytics';

import { withContext } from '../../App';

import './styles.scss';

class TopicCard extends Component {
  trackClick(){
    const { topic: { link } } = this.props;

    analytics.count({
      groupName: `topic-selection`,
      eventName: `Topic selected - ${link}`,
      unique: true
    });
  }

  render() {
    const { topic: { image, name, bgColor, opacity, link }, isMini, context: {scenariosComplete} } = this.props;

    return (
      <Link to={link} onClick={() => this.trackClick()}>
        <div className={`topic-card ${isMini ? 'card-mini' : ''}`}>
          <div className="topic-image" style={{ backgroundImage: `url(${image})` }}></div>
          <div className="topic-overlay" style={{ backgroundColor: bgColor, opacity: opacity ? opacity : '0.6' }}></div>
          <div className="topic-description">{name}</div>
          {
            (scenariosComplete.indexOf(link) !== -1 ) ? (
              <div className="topic-complete">&#10003;</div>
            ) : (
              <div className="topic-incomplete"></div>
            )
          }
        </div>
      </Link>
    );
  }
}

export default withContext(TopicCard);